<template>
  <a-modal
    :width="1000"
    title="回收站"
    @cancel="handleCancel"
    cancelText="关闭"
    :visible="visible">
    <template slot="footer">
      <a-button @click="handleCancel">关闭</a-button>
    </template>
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="modalFormOk">
        <a-row :gutter="24">
          <a-col :xl="8" :lg="7" :md="8" :sm="24">
            <a-form-item label="文件名">
              <a-input placeholder="请输入文件名" v-model="searchFileName" allowClear/>
            </a-form-item>
          </a-col>
          <a-col :xl="7" :lg="7" :md="8" :sm="24">
            <div class="table-operator">
              <a-button type="primary" class="rate-btn" @click="modalFormOk" icon="search">查询</a-button>
              <a-button type="primary" class="rate-btn" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
            </div>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="ant-alert ant-alert-info" >
      <a-row type="flex">
        <a-col flex="auto">
          <a-breadcrumb>
            <a-breadcrumb-item v-for="(item, index) in breadcrumbList" @click.native="breadcrumbClick(item.id)" :key="index">
              <a style=""> {{ item.name }}</a>
            </a-breadcrumb-item>
          </a-breadcrumb>
        </a-col>
      </a-row>
    </div>
    <a-table
      style="padding:10px;"
      :columns="columns"
      :data-source="dataSource"
      :pagination="false"
      :loading="loading"
    >
      <template slot="fileName" slot-scope="text,record">
        <a v-if="record.fileType === 1" STYLE="color: #2d9dff" @click="clickFile(record)"><a-icon type="folder-open" :style="iconFontSize" theme="twoTone"></a-icon> {{ text }}</a>
        <span v-if="record.fileType === 2"><a-icon type="file" :style="iconFontSize" theme="twoTone"></a-icon> {{ text }}</span>
        <span v-if="record.fileType === 3"><a-icon type="file-zip" :style="iconFontSize" theme="twoTone"></a-icon> {{ text }}</span>
        <span v-if="record.fileType === 4"><a-icon type="file-image" :style="iconFontSize" theme="twoTone"></a-icon> {{ text }}</span>
      </template>

      <template slot="action" slot-scope="text, record">
        <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
          <a>删除</a>
        </a-popconfirm>
        <a-popconfirm title="确定恢复吗?" @confirm="() => handleRestore(record.id)">
          <a style="margin-left: 8px" v-if="record.delNode === 1">恢复</a>
        </a-popconfirm>
      </template>
      <template slot="fileSize" slot-scope="text, record">
        <span>{{ text }} MB</span>
      </template>
    </a-table>
  </a-modal>
</template>
<script>
export default {
  name: 'recycleStorage',
  data() {
    return {
      visible: false,
      columns: [
        {
          title: '文件名',
          align: 'left',
          dataIndex: 'fileName',
          scopedSlots: {customRender: 'fileName'}
        },
        {
          title: '修改日期',
          align: 'center',
          dataIndex: 'updateTime'
        },
        {
          title: '文件大小（M）',
          align: 'center',
          dataIndex: 'fileSize',
          scopedSlots: {customRender: 'fileSize'}
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: {customRender: 'action'}
        }
      ],
      dataSource: [],
      iconFontSize: {fontSize: '20px'},
      searchFileName: '',
      breadcrumbList: [
        {
          id: 'home',
          name: '全部文件'
        }
      ],
      loading: false
    }
  },
  methods: {
    show() {
      this.visible = true
      this.searchQuery()
    },
    handleCancel() {
      this.visible = false
      this.dataSource = []
      this.breadcrumbList = [{
        id: 'home',
        name: '全部文件'
      }
      ]
      this.searchFileName = ''
      this.$emit('ok')
    },
    searchReset() {
      this.searchFileName = ''
      this.modalFormOk()
    },
    // 重载列表
    modalFormOk() {
      let currentNode = this.breadcrumbList[this.breadcrumbList.length - 1]
      this.lodata(currentNode.id)
    },
    // 点击导航栏
    breadcrumbClick(id) {
      let isdel = false
      for (let i = 0; i < this.breadcrumbList.length; i++) {
        if (isdel) {
          this.breadcrumbList.splice(i, this.breadcrumbList.length - i)
          break
        }
        if (this.breadcrumbList[i].id === id) {
          isdel = true
        }
      }
      this.lodata(id)
    },
    lodata(id) {
      if (id === 'home') {
        this.searchQuery()
      } else {
        this.searchQuery(id)
      }
    },
    clickFile(record) {
      this.searchQuery(record.id)
      this.breadcrumbList.push({'id': record.id, 'name': record.fileName})
    },
    searchQuery(val) {
      this.loading = true
      this.axios.get('/stu/fileStorage/storageRecycleList', { params: { id: val, fileName: this.searchFileName } }).then(res => {
        if (res.code === 200) {
          this.dataSource = res.result
        } else {
          this.dataSource = []
        }
      }).finally(() => {
        this.loading = false
      })
    },
    handleDelete(val) {
      this.axios.delete('/stu/fileStorage/delete', { params: { id: val, delType: '1' } }).then(res => {
        if (res.code === 200) {
          this.$message.success(res.message)
          this.modalFormOk()
        } else {
          this.$message.warning('删除失败')
        }
      })
    },
    // 恢复
    handleRestore(val) {
      this.axios.get('/stu/fileStorage/restore', { params: { id: val } }).then(res => {
        if (res.code === 200) {
          this.$message.success(res.message)
          this.modalFormOk()
        } else {
          this.$message.warning('操作失败')
        }
      })
    }
  }
}
</script>
<style scoped>
.rate-btn {
  background: #2caf7a;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/pages/PersonalCenters/components/recycleStorage.vue